import { apiConverter } from '@front/repository/Api/converter';
import { getApiClient } from '@front/repository/common/apiClient';
import type { IImportTaskRepository as I } from './interface';

export class ImportTaskRepository implements I {
  get: I.Get = async (params, options) => {
    const res = await getApiClient().POST('/contracts/import/get', {
      body: {
        projectId: params.projectId,
        id: params.id,
      },
      signal: options?.signal,
    });
    if (!res.response.ok) throw new Error('Failed to get import task');
    return res.data ? apiConverter.ImportTask.fromApiWithRelations(res.data) : undefined;
  };

  list: I.List = async (params, options) => {
    const res = await getApiClient().POST('/contracts/import/list', {
      body: {
        projectId: params.projectId,
        importTableDefinitionId: params.importTableDefinitionId,
        importTableDefinitionRevisionId: params.importTableDefinitionRevisionId,
      },
      signal: options?.signal,
    });
    if (!res.data) throw new Error('Failed to list import tasks');
    return res.data.map(apiConverter.ImportTask.fromApiWithRelations);
  };

  start: I.Start = async (params, options) => {
    const res = await getApiClient().POST('/contracts/import', {
      body: {
        projectId: params.projectId,
        importTableDefinitionId: params.importTableDefinitionId,
        importTableDefinitionRevisionId: params.importTableDefinitionRevisionId,
        fileId: params.fileId,
      },
      signal: options?.signal,
    });
    if (!res.data?.task) throw new Error('Failed to start import task');
    return apiConverter.ImportTask.fromApi(res.data.task);
  };
}
